import React, { useState } from 'react';
import { DeclinedAccessLevelRequest } from '../types';
import { useSonTranslation } from '../../../../translation/useSonTranslation';
import { Heading } from '../../../../_lib/components/Heading/Heading';
import { TooltipPlacement } from '../../../../components/atoms/Tooltip';
import { BtnModifier } from '../../../../components/molecules/Btn';
import { Button } from '../../../../components/molecules/Btn/Button';
import { Icons } from '../../../../components/atoms/SVG';
import ModalDialog from '../../../../components/organisms/ModalDialog/ModalDialog';
import { AcceptDeclineForm, SonForm } from '../../../../_lib/Form2';
import { useDelayed } from '../../../../hooks/useDelayed';
import { AnyParameter } from '../../../../_lib/Form2/types/SonForm';
import { useRefreshBlock } from '../../../../_lib/BlockFetcher';
import TextBubble from '../../../../_lib/components/TextBubble/TextBubble';
import { formatDate, TimeFormats } from '../../../../lib/DateFormat';

type DeclinedAccessLevelRequestInformationProps = {
  declinedRequest: DeclinedAccessLevelRequest;
  removeDeclinedRequestForm: SonForm<AnyParameter> | undefined;
};

export function DeclinedAccessLevelRequestInformation({
  declinedRequest,
  removeDeclinedRequestForm,
}: DeclinedAccessLevelRequestInformationProps) {
  const { t } = useSonTranslation('AccessLevel');
  const [showAcceptDecline, setShowAcceptDecline] = useState(false);

  const { refresh } = useRefreshBlock();
  const delayedOnSuccess = useDelayed(() => {
    setShowAcceptDecline(false);
    refresh();
  });

  const date = formatDate(declinedRequest.declinedAt, TimeFormats.DAY_MONTH_YEAR) || '';

  return (
    <div className="access-level__declined-request-info">
      <div className="access-level__declined-request-info-top-container">
        <Heading className="access-level__declined-request-info-headline font-bold-15-19" hierarchy={3}>
          {t('declinedRequest', { date })}
        </Heading>
        {removeDeclinedRequestForm
          ? (
              <Button
                type="button"
                title={t('removeDeclinedRequest.headline')}
                tooltipPlacement={TooltipPlacement.TOP}
                hideTooltipFromScreenReader
                modifier={[BtnModifier.MINOR_ACTION, BtnModifier.TRANSPARENT]}
                onClick={() => setShowAcceptDecline(!showAcceptDecline)}
              >
                <Button.Icon svgSpriteId={Icons.DELETE_TRASHCAN} text={t('removeDeclinedRequest.headline')} />
              </Button>
            )
          : null}
      </div>
      <TextBubble content={declinedRequest.declineReason} />
      {showAcceptDecline && removeDeclinedRequestForm
        ? (
            <ModalDialog closeModal={() => setShowAcceptDecline(false)} headline={t('removeDeclinedRequest.headline')}>
              <AcceptDeclineForm
                headline={t('removeDeclinedRequest.description')}
                form={removeDeclinedRequestForm}
                onSuccess={delayedOnSuccess}
                messageSuccess={t('removeDeclinedRequest.status.success')}
                messageSending={t('removeDeclinedRequest.status.sending')}
                messageFail={t('removeDeclinedRequest.status.fail')}
              />
            </ModalDialog>
          )
        : null}
    </div>
  );
}
